export default "__VITE_ASSET__COUe$qDV__"